var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.583 1.75L0.583 4.083 13.417 4.083 13.417 1.75",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0275B6",
    fillRule: "nonzero",
    stroke: "#0275B6",
    strokeWidth: 0.4,
    d: "M10.5 1.167V0h-.583v1.167H4.083V0H3.5v1.167H0V14h14V1.167h-3.5zm2.917 12.25H.583v-8.75h12.834v8.75zm0-9.334H.583V1.75H3.5v1.167h.583V1.75h5.834v1.167h.583V1.75h2.917v2.333z",
    transform: "translate(2 2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.90e91baff4f0ed16a0f02af9d1888c72.svg";
export { ForwardRef as ReactComponent };